import { Pipe, PipeTransform } from '@angular/core';
// import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Pipe({
    name: 'dateCulturePipe',
})
export class dateCulturePipe implements PipeTransform {
    transform(value: any) {
        if (value) {
            //value = moment.utc(value).local();
            //value = value;
            value = value.replace(/\s/g, "T");
        }

        return value;
    }
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/pipes/date-culture-pipe.ts